// extracted by mini-css-extract-plugin
module.exports = {"container":"services-module--container--3lcJG","info":"services-module--info--24Es8"};